/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CoursefinancialCoursefinancialidClasses200,
  GetApiV1CoursefinancialCoursefinancialidClasses400,
  GetApiV1CoursefinancialCoursefinancialidClasses401,
  GetApiV1CoursefinancialCoursefinancialidClasses404,
  GetApiV1CoursefinancialCoursefinancialidClasses500,
  GetApiV1CoursefinancialCoursefinancialidClassesPathParams,
  GetApiV1CoursefinancialCoursefinancialidClassesQueryParams,
  GetApiV1CoursefinancialCoursefinancialidClassesQueryResponse,
} from "../../types/courseFinancialClassesController/GetApiV1CoursefinancialCoursefinancialidClasses.ts";
import { courseFinancialClassStudentViewModelPaginatedResponseSchema } from "../courseFinancialClassStudentViewModelPaginatedResponseSchema.ts";

export const getApiV1CoursefinancialCoursefinancialidClassesPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClassesPathParams>;

export const getApiV1CoursefinancialCoursefinancialidClassesQueryParamsSchema =
  z.object({
    Search: z.optional(
      z
        .string()
        .describe("Texto livre aplicado à descrição do plano. Opcional."),
    ),
    Active: z.optional(
      z
        .boolean()
        .describe(
          "Filtra por situação do plano. Quando omitido, retorna ativos e inativos. No legado esse filtro era aplicado apenas no grid.",
        ),
    ),
    PageNumber: z.coerce
      .number()
      .int()
      .default(1)
      .describe("Página da listagem. Mínimo 1."),
    PageSize: z.coerce
      .number()
      .int()
      .default(30)
      .describe("Quantidade de itens por página. Entre 1 e 100."),
  }) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClassesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CoursefinancialCoursefinancialidClasses200Schema = z.lazy(
  () => courseFinancialClassStudentViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClasses200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CoursefinancialCoursefinancialidClasses400Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClasses400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CoursefinancialCoursefinancialidClasses401Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClasses401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CoursefinancialCoursefinancialidClasses404Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClasses404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CoursefinancialCoursefinancialidClasses500Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClasses500>;

export const getApiV1CoursefinancialCoursefinancialidClassesQueryResponseSchema =
  z.lazy(
    () => getApiV1CoursefinancialCoursefinancialidClasses200Schema,
  ) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClassesQueryResponse>;
